// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ofTO_eU7WrCxP9FvEHQf {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  touch-action: pan-y;
  background-color: var(--vnsc-bg-primary, #0c1017);
}

.qVTUwJHnHWztu6Nm1VEg {
  display: flex;
  height: 100%;
  will-change: transform;
}

.NZ08Gw3Joob5zHyaNqah {
  height: 100%;
  flex-shrink: 0;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/components/MobileChartCarousel.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".carouselContainer {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  touch-action: pan-y;\r\n  background-color: var(--vnsc-bg-primary, #0c1017);\r\n}\r\n\r\n.carouselTrack {\r\n  display: flex;\r\n  height: 100%;\r\n  will-change: transform;\r\n}\r\n\r\n.carouselSlide {\r\n  height: 100%;\r\n  flex-shrink: 0;\r\n  position: relative;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carouselContainer": `ofTO_eU7WrCxP9FvEHQf`,
	"carouselTrack": `qVTUwJHnHWztu6Nm1VEg`,
	"carouselSlide": `NZ08Gw3Joob5zHyaNqah`
};
export default ___CSS_LOADER_EXPORT___;
